import React from 'react';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import { calculateLastActive } from 'utils/date';
import NoteItem from './NoteItem';
import './Notes.scss';

class Notes extends React.Component {
  prepareNotes = () => {
    let notesList = [];
    notesList = this.props.notes.map((note, index) => {
      let createdAt = note.created_at;
      return (
        <li key={note.id}>
          <NoteItem
            title="Note"
            text={note.text}
            id={note.id}
            lastActive={
              createdAt ? `${calculateLastActive(createdAt)} ago` : ''
            }
            clientId={this.props.client.id}
          />
        </li>
      );
    });
    return notesList;
  };

  render() {
    let notes = this.prepareNotes();
    if(this.props.loading){
      return(<Loader />);
    }
    return (
      <section className="notes-tab">
        <div className="notes-list">
          <ul>{notes}</ul>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.notesReducer.loading
  };
}

export default connect(
  mapStateToProps,
  null
)(Notes);
